import React, { useEffect, useState, Fragment } from "react";
import { Typography, makeStyles, Grid, Button } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

//images
import EROSION from "../../../../../images/pictos-ok/Erosion.svg";
import Coupe_Forestiere from "../../../../../images/pictos-ok/Coupe-forestiere.svg";
import Construction_trop_visible from "../../../../../images/pictos-ok/Constructiontropvisible.svg";
import Espece_protegee_identifiee from "../../../../../images/pictos-ok/Espece-protegee.svg";
import Depart_de_feu from "../../../../../images/pictos-ok/Depart-de feu.svg";
import AUTRE from "../../../../../images/pictos-ok/AUTRE.svg";

import Dechets_sauvages from "../../../../../images/pictos-ok/Dechets-sauvageS.svg";
import BRUIT from "../../../../../images/pictos-ok/bruit.svg";
import Pollution_lumineuse from "../../../../../images/pictos-ok/Pollution-lumineuse.svg";
import Pollution_de_l_air from "../../../../../images/pictos-ok/Pollution-de l’air.svg";
import Pollution_de_l_eau from "../../../../../images/pictos-ok/Pollution-de l’eau.svg";

const useStyles = makeStyles((theme) => ({
  themeButton: {
    borderRadius: "12px",
    backgroundColor: "white",
    height: 140,
    width: 140,
    "&:hover": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:active": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:focus": {
      border: "2px solid red",
      backgroundColor: "white",
    },
  },
  gridCell: {
    display: "flex",
    alignItems: "center",
  },
  switchButton: {
    borderRadius: "12px",
    backgroundColor: "white",
    width: "95%",
    height: 80,
    margin: "auto",
    "&:hover": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:active": {
      border: "2px solid red",
      backgroundColor: "white",
    },
    "&:focus": {
      border: "2px solid red",
      backgroundColor: "white",
    },
  },
}));

const Step2 = (props) => {
  const classes = useStyles();
  const [affichage, setAffichage] = useState(false);

  useEffect(() => {
    // Quand le composant se charge, n'autorise pas à passer à la suite
    props.setAuthorization(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["sujet"] = event.currentTarget.getAttribute("sujet");
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
    props.goForth(true);
  };

  /**
   * @description Affiche une grille de 3*3 qui propose des options sur la faune et la flore
   * @returns JSX component
   */
  const affichageFalse = () => {
    return (
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Première ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="erosion"
          >
            <img
              src={EROSION}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Érosion
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="coupe_forestiere"
          >
            <img
              src={Coupe_Forestiere}
              alt="coupe forestièrer"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Coupe Forestière
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="construction trop visible "
          >
            <img
              src={Construction_trop_visible}
              alt="construction trop visible"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Construction trop visible
          </Button>
        </Grid>
        {/* Deuxième ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="espece_protegee"
          >
            <img
              src={Espece_protegee_identifiee}
              alt="espèce protégée"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Espèce protégée identifée
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Depart_de_feu"
          >
            <img
              src={Depart_de_feu}
              alt="départ de feu"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Départ de feu
          </Button>
        </Grid>
        {/* Troisième ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="autre"
          >
            <img
              src={AUTRE}
              alt="Autre"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Autre
          </Button>
        </Grid>

        {/* Quatrième ligne */}
        <Grid item xs={12} className={classes.gridCell}>
          <Button
            className={classes.switchButton}
            onClick={() => {
              setAffichage(!affichage);
            }}
          >
            Faire une observation sur la pollution <ArrowRightAltIcon />
          </Button>
        </Grid>
      </Grid>
    );
  };

  /**
   * @description Affiche une grille de 3*3 qui propose des options sur les paysages
   * @returns JSX component
   */
  const affichageTrue = () => {
    return (
      <Grid container spacing={2} style={{ maxWidth: "100%" }}>
        {/* Première ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="Dechets_sauvages"
          >
            <img
              src={Dechets_sauvages}
              alt="à venir"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Déchets sauvages
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="bruit"
          >
            <img
              src={BRUIT}
              alt="bruit"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Bruit
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="pollution_lumineuse"
          >
            <img
              src={Pollution_lumineuse}
              alt="Pollution lumineuse"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Pollution lumineuse
          </Button>
        </Grid>
        {/* Deuxième ligne */}
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet=" pollution_de_l_air"
          >
            <img
              src={Pollution_de_l_air}
              alt="pollution de l'air"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Pollution de l'air
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="pollution_de_l_eau"
          >
            <img
              src={Pollution_de_l_eau}
              alt="pollution de l'eau"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Pollution de l'eau
          </Button>
        </Grid>
        <Grid item xs={6} className={classes.column}>
          <Button
            className={classes.themeButton}
            classes={{ label: "labelButton" }}
            onClick={handleChange}
            sujet="autre"
          >
            <img
              src={AUTRE}
              alt="autre"
              style={{ maxHeight: 65, maxWidth: "100%", marginBottom: "10px" }}
            />
            Autre
          </Button>
        </Grid>

        {/* Quatrième ligne */}
        <Grid item xs={12} className={classes.gridCell}>
          <Button
            className={classes.switchButton}
            onClick={() => {
              setAffichage(!affichage);
            }}
          >
            Qualifier le risque <ArrowRightAltIcon />
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Fragment>
      <Typography
        variant="body1"
        component="legend"
        style={{ marginLeft: 20, marginBottom: 20 }}
      >
        Veuillez sélectionner le sujet sur lequel vous avez eu des informations
        :
      </Typography>
      {/* Charge l'affichage conditionnel des 18 cases possibles */}
      {affichage ? affichageTrue() : affichageFalse()}
    </Fragment>
  );
};

export default Step2;
